module.exports = __webpack_public_path__ + "img/event.31e10de5.png";